var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationBuildings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 70h28V10H26v60zm29 2H25a1 1 0 01-1-1V9a1 1 0 011-1h30a1 1 0 011 1v62a1 1 0 01-1 1z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M28 63h24v-2H28z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M30 71h2v-9h-2zM48 71h2v-9h-2zM39 71h2v-9h-2zM43 67h2v-2h-2zM35 67h2v-2h-2zM47 56h2v-2h-2v2zm3 2h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1zM39 56h2v-2h-2v2zm3 2h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1zM31 56h2v-2h-2v2zm3 2h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1zM47 47h2v-2h-2v2zm3 2h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 47h2v-2h-2v2zm3 2h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 47h2v-2h-2v2zm3 2h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1zM47 38h2v-2h-2v2zm3 2h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1zM39 38h2v-2h-2v2zm3 2h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 38h2v-2h-2v2zm3 2h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1zM47 29h2v-2h-2v2zm3 2h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 29h2v-2h-2v2zm3 2h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1zM31 29h2v-2h-2v2zm3 2h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1zM47 20h2v-2h-2v2zm3 2h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1zM39 20h2v-2h-2v2zm3 2h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 20h2v-2h-2v2zm3 2h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 70h14V31H56v39zm15 2H55a1 1 0 01-1-1V30a1 1 0 011-1h16a1 1 0 011 1v41a1 1 0 01-1 1z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M58 36h2v-2h-2zM62 36h2v-2h-2zM66 36h2v-2h-2zM58 40h2v-2h-2zM62 40h2v-2h-2zM66 40h2v-2h-2zM58 54h2v-2h-2zM62 54h2v-2h-2zM66 54h2v-2h-2zM58 58h2v-2h-2zM62 58h2v-2h-2zM66 58h2v-2h-2zM58 45h2v-2h-2zM62 45h2v-2h-2zM66 45h2v-2h-2zM58 49h2v-2h-2zM62 49h2v-2h-2zM66 49h2v-2h-2zM29 14h22v-2H29zM58 30h2v-3h-2zM67 30h2v-3h-2zM55 63h16v-2H55zM55 67h16v-2H55zM10 70h14V31H10v39zm15 2H9a1 1 0 01-1-1V30a1 1 0 011-1h16a1 1 0 011 1v41a1 1 0 01-1 1z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M12 36h2v-2h-2zM16 36h2v-2h-2zM20 36h2v-2h-2zM12 40h2v-2h-2zM16 40h2v-2h-2zM20 40h2v-2h-2zM12 54h2v-2h-2zM16 54h2v-2h-2zM20 54h2v-2h-2zM12 58h2v-2h-2zM16 58h2v-2h-2zM20 58h2v-2h-2zM12 45h2v-2h-2zM16 45h2v-2h-2zM20 45h2v-2h-2zM12 49h2v-2h-2zM16 49h2v-2h-2zM20 49h2v-2h-2zM12 30h2v-3h-2zM21 30h2v-3h-2zM9 63h16v-2H9zM9 67h16v-2H9z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationBuildings;